import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
            精彩花絮
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
            幕后故事、OST合集、花絮访谈一网打尽
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {mediaData.slice(0, 3).map((item, idx) => (
              <div
                key={idx}
                className="group rounded-xl bg-background-100 border border-background-200 overflow-hidden hover:shadow-sm transition-all duration-200 cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
                  <div className="absolute bottom-3 right-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-foreground-950/60 text-background-50 text-xs">
                    <i className="ri-play-fill text-sm"></i>
                    {item.duration}
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-medium text-foreground-950 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
            {mediaData.slice(3, 5).map((item, idx) => (
              <div
                key={idx + 3}
                className="group rounded-xl bg-background-100 border border-background-200 overflow-hidden hover:shadow-sm transition-all duration-200 cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                    onError={(e) => {
                      const target = e.currentTarget;
                      target.style.display = 'none';
                    }}
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>
                  <div className="absolute bottom-3 right-3 flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-foreground-950/60 text-background-50 text-xs">
                    <i className="ri-play-fill text-sm"></i>
                    {item.duration}
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-medium text-foreground-950 text-sm md:text-base mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}